var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('menu-dashboard'),_c('div',{staticStyle:{"margin-top":"90px","margin-bottom":"90px"}},[_c('router-view')],1),_c('footer-dashboard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }